export default __webpack_public_path__ + "static/media/peach.767cfcde.gif";